// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

const hospitalRefSchema = z.object({
  id: z.number(),
  name: z.string(),
  uuid: z.string(),
})

const permissaoSchema = z.object({
  id: z.number(),
  descricao: z.string(),
  codigo: z.string().nullable(),
})

/**
 * Usuário autenticado. Substitui o payload de POST /auth/validation.
 * `.strip()` (default do Zod object) garante que `hash` nunca trafega — campos extras são descartados.
 */
export const meUserSchema = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string().nullable(),
  role_id: z.number(),
  roles: z.array(z.number()),
  hospitals: z.array(hospitalRefSchema),
  permissoes: z.array(permissaoSchema),
})
export type MeUser = z.infer<typeof meUserSchema>

export const meResponseSchema = z.object({ user: meUserSchema })
export type MeResponse = z.infer<typeof meResponseSchema>

/** Resposta 200 de login direto / verify-mfa / refresh. Cookies httpOnly fora do body. */
export const authSuccessSchema = z.object({
  accessToken: z.string(),
  expiresIn: z.number(),
  expiresAt: z.number(),
  csrfToken: z.string(),
  user: meUserSchema,
})
export type AuthSuccess = z.infer<typeof authSuccessSchema>
